"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDashboardNavigationInfo = void 0;
const react_1 = require("react");
const react_query_1 = require("@tanstack/react-query");
const __1 = require("..");
const _1 = require(".");
const useDashboardNavigationInfo = (dashboardId) => {
    const httpClient = (0, __1.useHttpClient)();
    const dashboardsNavigationGraphQueryOptions = (0, _1.getDashboardsNavigationGraphQueryOptions)(httpClient);
    const dashboardsNavigationMetaQueryOptions = (0, _1.getDashboardsNavigationMetaQueryOptions)(httpClient);
    const queries = [
        dashboardsNavigationGraphQueryOptions,
        dashboardsNavigationMetaQueryOptions
    ];
    const queriesResults = (0, react_query_1.useQueries)({ queries });
    const [graphQuery, metaQuery] = queriesResults;
    return (0, react_1.useMemo)(() => {
        var _a, _b;
        const graph = (_a = graphQuery.data) === null || _a === void 0 ? void 0 : _a[dashboardId];
        const meta = (_b = metaQuery.data) === null || _b === void 0 ? void 0 : _b[dashboardId];
        const isFetching = queriesResults.some((result) => result.isFetching);
        const isFetched = queriesResults.every((result) => result.isFetched);
        return {
            isFetching,
            isFetched,
            data: isFetched && graph && meta ? Object.assign(Object.assign({}, graph), meta) : undefined
        };
    }, [dashboardId, queriesResults, graphQuery, metaQuery]);
};
exports.useDashboardNavigationInfo = useDashboardNavigationInfo;
